import { TargetShapeGeo } from 'types/models/SessionEnrichment';

/** The aimed-at target (isActive) is yellow; the rest are drawn gray — shared by the 3D and the top view. */
export const TARGET_ACTIVE_COLOR = '#ffd21e';
export const TARGET_INACTIVE_COLOR = '#8b8f98';

/** Footprint area of a target, used to layer big shapes under small ones. */
export function targetArea(target: TargetShapeGeo): number {
  if (target.shape === 'circle') {
    const outer = Math.max(target.innerRadius ?? 0, target.outerRadius ?? 0, 0);
    return Math.PI * outer * outer;
  }
  if (target.shape === 'rectangle') {
    return Math.max(0, target.xLength ?? 0) * Math.max(0, target.zLength ?? 0);
  }
  return 0;
}

/** Draw order: the active target last (on top), and otherwise large shapes before small ones so none hides another. */
export function layerTargets(targets: ReadonlyArray<TargetShapeGeo> | undefined): TargetShapeGeo[] {
  return [...(targets ?? [])].sort((a, b) => {
    if (Boolean(a.isActive) !== Boolean(b.isActive)) return a.isActive ? 1 : -1;
    return targetArea(b) - targetArea(a);
  });
}
